module.exports = {"name":"dao","comment":"DAO rescue hardfork","eip":{"url":"https://eips.ethereum.org/EIPS/eip-779","status":"Final"},"gasConfig":{},"gasPrices":{},"vm":{},"pow":{},"casper":{},"sharding":{}}


//////////////////
// WEBPACK FOOTER
// ./~/ethereumjs-common/dist/hardforks/dao.json
// module id = 1067
// module chunks = 0 1 2